import { render, staticRenderFns } from "./changePhoneNumber.vue?vue&type=template&id=f8f321c6&scoped=true"
import script from "./changePhoneNumber.vue?vue&type=script&lang=js"
export * from "./changePhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./changePhoneNumber.vue?vue&type=style&index=0&id=f8f321c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f321c6",
  null
  
)

export default component.exports